import React, {useEffect, useState} from "react";
import ContactSearch from "./ContactSearch";
import {Info} from "react-feather";

const ContactBlock = ({
                          isMultiple = true,
                          allVendorAccounts,
                          onContactSelect,
                          skipCreate,
                          disabled = false,
                          isPrimary = false,
                          type,
                          selectedContacts,
                          onUserCreated,
                          onRemoveContact
                      }) => {
    const [currentSelectedContacts, setCurrentSelectedContacts] = useState([null]);

    const onSelect = (contact, index = -1) => {
        const tempContacts = [...currentSelectedContacts];
        let prevContactId;
        let isUpdate = false;
        if (index === -1) {
            tempContacts.push(contact);
        } else {
            if (tempContacts[index] && contact && tempContacts[index]?.id !== contact?.id) {
                isUpdate = true;
                prevContactId = tempContacts[index].id;
            }
            tempContacts[index] = contact;
        }

        setCurrentSelectedContacts(tempContacts)
        onContactSelect(tempContacts, contact, type, isUpdate ? prevContactId : false);
    }


    useEffect(() => {
        if (selectedContacts && selectedContacts[type])
            setCurrentSelectedContacts(selectedContacts[type]);
    }, [currentSelectedContacts, selectedContacts, type])

    const onDeleteContact = async (index, contact) => {
        try {
            await onRemoveContact(contact.id, type);
            const tempContacts = [...currentSelectedContacts];
            tempContacts.splice(index, 1);
            // Keep an empty "Select a user" field when the last contact is removed
            const nextContacts = tempContacts.length > 0 ? tempContacts : [null];
            setCurrentSelectedContacts(nextContacts);
            onContactSelect(nextContacts, null, type);

        } catch (e) {
            console.log(e)
        }
    }

    const canAddMore = currentSelectedContacts.filter(contact => contact === null).length > 0;
    const limitReached = currentSelectedContacts.length >= 5;

    return (
        <div className={"sl-w-full"}>
            <div className="sl-flex sl-flex-col sl-gap-4 sl-align-stretch">
                {currentSelectedContacts.map((contact, index) => <ContactSearch
                    onUserCreated={onUserCreated}
                    key={index}
                    type={type}
                    skipCreate={skipCreate}
                    disabled={disabled}
                    isPrimary={isPrimary}
                    onDeleteContact={() => onDeleteContact(index, contact)}
                    onContactSelect={(res) => onSelect(res, index)}
                    allVendorAccounts={allVendorAccounts}
                    selectedContacts={currentSelectedContacts}
                    selectedContact={contact}/>)}

                {isMultiple && !limitReached && <div
                    style={{opacity: canAddMore ? 0.5 : 1, pointerEvents: canAddMore ? 'none' : 'auto'}}
                    className="sl-flex sl-flex-row sl-gap-2 sl-cursor-pointer sl-flex sl-justify-flex-start sl-align-center"
                    onClick={() => {
                        setCurrentSelectedContacts([...currentSelectedContacts, null])
                        onContactSelect([...currentSelectedContacts, null], null, type)
                    }}
                >
                    <span className={"sl-text-primary-700 sl-font-medium sl-text-sm sl-font"}>+ Add another</span>
                </div>}

                {isMultiple && limitReached &&
                    <span
                        className={"sl-text-gray-700 sl-font sl-text-sm sl-flex sl-flex-row sl-gap-1 sl-align-center sl-font"}><Info
                        size={16}
                        color={"#98A2B3"}/> A maximum of 5 users can be assigned.</span>}


            </div>
        </div>
    );
}
export default ContactBlock;